import axios from "axios";
import {
  AuthenticationApiFactory,
  Configuration,
  FirewallApiFactory,
  ItemApiFactory,
  LogApiFactory,
  OpenAIApiFactory,
  FTPApiFactory,
  SettingsApiFactory,
  SubscriptionsApiFactory,
  TicketsApiFactory,
  UsersApiFactory,
  VouchersApiFactory,
  TasksApiFactory,
  NotificationsApiFactory,
  DashboardApiFactory,
  DepartmentsApiFactory,
  PrintApiFactory,
  ProductApiFactory,
  APIApiFactory,
  WebhookApiFactory,
  BrandingApiFactory,
  FilterViewApiFactory,
  ImportApiFactory,
  CompanyApiFactory,
  ContactApiFactory,
} from "./swagger";
import settings from "../settings";

const configuration = new Configuration();

export const LogService = LogApiFactory(configuration, settings.baseUrl, axios);

export const ApiService = APIApiFactory(configuration, settings.baseUrl, axios);

const authApi = AuthenticationApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const AuthService = {
  ...authApi,
  login: (
    requestParameters: Parameters<typeof authApi.login>[0],
    options?: Parameters<typeof authApi.login>[1],
  ) => authApi.login(requestParameters, { ...options, toastOn401: true }),
  otpLogin: (
    requestParameters: Parameters<typeof authApi.otpLogin>[0],
    options?: Parameters<typeof authApi.otpLogin>[1],
  ) => authApi.otpLogin(requestParameters, { ...options, toastOn401: true }),
};

export const BrandingService = BrandingApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const DepartmentService = DepartmentsApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const CalendarService = LogApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const CompanyService = CompanyApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const ContactService = ContactApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const FirewallService = FirewallApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const ImportService = ImportApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const ItemService = ItemApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const NotificationService = NotificationsApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const OpenAiService = OpenAIApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const FilterViewService = FilterViewApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const FtpService = FTPApiFactory(configuration, settings.baseUrl, axios);

export const PrintService = PrintApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const ProductService = ProductApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const SettingsService = SettingsApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const SubscriptionService = SubscriptionsApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const TicketService = TicketsApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const TaskService = TasksApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

const usersApi = UsersApiFactory(configuration, settings.baseUrl, axios);

export const UserService = {
  ...usersApi,
  // Rethrows HTTP errors so the register page can catch the 409
  // account-exists case and redirect to /login.
  createRegisteredUser: (
    requestParameters: Parameters<typeof usersApi.createRegisteredUser>[0],
    options?: Parameters<typeof usersApi.createRegisteredUser>[1],
  ) =>
    usersApi.createRegisteredUser(requestParameters, {
      ...options,
      rethrow: true,
    } as any),
};

export const DashboardService = DashboardApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const VoucherService = VouchersApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);

export const WebhookService = WebhookApiFactory(
  configuration,
  settings.baseUrl,
  axios,
);
